module.exports = __webpack_public_path__ + "img/imagen-registro.96470bde.png";